import {NgModule} from '@angular/core';
import {PluginMessageDaoService} from './plugin-message-dao.service';

@NgModule({
    imports: [],
    providers: [PluginMessageDaoService]
})
export class PluginMessageModule {
}
